import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import {
    ApproveTaskRegular,
    DeclineTaskRegular,
    CancelTaskRegular,
    RequestReviewDCFromWeb,
    RequestReviewRegular,
    sendTaskRegularReminder,
    sendTaskDocumentReminder,
    ArchiveTaskRegular,
    UnArchiveTaskRegular,
} from '../../../../services/api/task-api';
import ApprovePanelPowerpoint from '../../../../components/approvePanelPowerpoint/approvePanelPowerpoint';
import { UpdateDocumentTaskWeb } from '../../../../services/api/document-api';
import { LoginContext } from '../../../../services/api/authentication-api';
import { trackPromise } from 'react-promise-tracker';
import { PulseLoader } from "react-spinners";
import './tasks-actions-panel.scss';
// Shared modal-header utility (the `.header-popup` rule) — used by the `<Modal.Header
// className="header-popup">` rendered in this file's actions panel.
import '../tasks-comments/shared-modal-header.scss';
import { viewPowerpointDocument, submitPowerpointDocument } from '../../../../redux/tasks/task-actions';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsLoadingDocument, selectIsSubmittingTask, selectApiError } from "../../../../redux/tasks/task-selector";
import { errorNotification, successNotification } from '../../../../redux/notifications';
import { TaskStatusTypes } from "./task-status-types";

const getNotifyType = (type) => {
    const caseIntro = "Remind";
    switch (type) {
        case `${caseIntro} Editors to Start Working`:
            return 3;
        case `${caseIntro} Reviewers to Review`:
            return 2;
        case `${caseIntro} Editors to Request Review`:
            return 1;
        default:
            return 0;
    }
};

const TasksActionsPanelNew = ({
    show,
    onHide,
    type,
    task,
    button,
    refreshTasks,
    editPage,
    labels,
    customLabel,
}) => {
    const [comment, setComment] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isLoadingReminder, setIsLoadingReminder] = useState(false);

    const btnRef = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const loginContext = useContext(LoginContext);

    const isLoadingDocument = useSelector(selectIsLoadingDocument);
    const isSubmittingTask = useSelector(selectIsSubmittingTask);
    const errorMessage = useSelector(selectApiError);
    const prevIsSubmitting = useRef(isSubmittingTask);

    const dispatchSuccess = useCallback((notification) => dispatch(successNotification(notification)), [dispatch]);
    const dispatchError = useCallback((notification) => dispatch(errorNotification(notification)), [dispatch]);

    useEffect(() => {
        setIsLoadingReminder(false);
    }, []);

    useEffect(() => {
        if (prevIsSubmitting.current && !isSubmittingTask) {
            const actionType = type.slice(0, type.indexOf(" Task"));
            if (actionType === "") return;
            if (getNotifyType(type)) return;

            onHide();
            if (errorMessage === "") {
                dispatchSuccess({
                    header: actionType + " Task",
                    message: `${task.Name} ${actionType !== "Cancel" ? actionType : (actionType + 'le')}d`,
                });
            } else {
                dispatchError({
                    header: actionType + " Task",
                    message: `${task.Name} Not ${actionType !== "Cancel" ? actionType : (actionType + 'le')}d`,
                });
            }
            refreshTasks();
        }
        prevIsSubmitting.current = isSubmittingTask;
    }, [isSubmittingTask, errorMessage, type, task, onHide, refreshTasks, dispatchSuccess, dispatchError]);

    const submitPPTAction = async (commentText) => {
        setIsLoadingReminder(true);
        const actionType = type.slice(0, type.indexOf(" Task"));

        const object = { notifyType: getNotifyType(type), workItemId: task.Id, userId: loginContext.userID, comment };
        if (object.notifyType) {
            onSendingCollaborationReminder(object);
        }
        if (actionType !== "") {
            await dispatch(viewPowerpointDocument(task.Id));
            await dispatch(submitPowerpointDocument(task.Id, actionType, commentText));
        }
    };

    const onSendingCollaborationReminder = (object) => {
        trackPromise(
            sendTaskDocumentReminder(object).then(
                () => {
                    onHide();
                    dispatchSuccess({ header: "Send Reminder", message: `Reminder sent for ${task.Name}` });
                    refreshTasks();
                },
                () => {
                    onHide();
                    dispatchError({ header: "Send Reminder", message: `Could not send reminder for ${task.Name}` });
                }
            )
        );
    };

    const notifyResult = (header, successMsg, failMsg, apiCall) => {
        trackPromise(
            apiCall.then(
                () => {
                    onHide();
                    editPage
                        ? history.push("/tasks?tab=active&alert=" + JSON.stringify({ showAlert: true, alertAction: successMsg, alertVariant: "success", alertMessage: "" }))
                        : dispatchSuccess({ header, message: successMsg });
                    refreshTasks();
                },
                (error) => {
                    onHide();
                    editPage
                        ? history.push("/tasks?tab=active&alert=" + JSON.stringify({ showAlert: true, alertAction: failMsg, alertVariant: "danger", alertMessage: error.toString() }))
                        : dispatchError({ header, message: failMsg });
                }
            )
        );
    };

    const notifyResultSimple = (header, successMsg, failMsg, apiCall) => {
        trackPromise(
            apiCall.then(
                () => {
                    onHide();
                    dispatchSuccess({ header, message: successMsg });
                    refreshTasks();
                },
                () => {
                    onHide();
                    dispatchError({ header, message: failMsg });
                }
            )
        );
    };

    const submitAction = async () => {
        setIsLoadingReminder(true);
        if (btnRef.current) {
            btnRef.current.setAttribute("disabled", "disabled");
        }

        const obj = { TaskId: task.Id, Note: comment, Comment: comment, Action: type, Files: selectedFiles };
        const taskLabel = labels?.TaskSingular ?? "Task";

        // DOCUMENT TASKS
        if (task.TaskTypeId === 0) {
            if (task.DocumentTypeId !== 2) {
                if (type === "Approve Task") {
                    obj.ActionId = TaskStatusTypes.APPROVED;
                    notifyResult(`Approve ${taskLabel}`, `${task.Name} approved`, `Failed to approve ${task.Name}`, UpdateDocumentTaskWeb(obj));
                } else if (type === "Complete Task") {
                    obj.ActionId = TaskStatusTypes.COMPLETED;
                    notifyResult(`Complete ${taskLabel}`, `${task.Name} completed`, `Failed to complete ${task.Name}`, UpdateDocumentTaskWeb(obj));
                } else if (type === "Decline Task") {
                    obj.ActionId = TaskStatusTypes.DECLINED;
                    notifyResult(`Decline ${taskLabel}`, `${task.Name} declined`, `Failed to decline ${task.Name}`, UpdateDocumentTaskWeb(obj));
                } else if (type === "Cancel Task") {
                    obj.ActionId = TaskStatusTypes.CANCELLED;
                    notifyResultSimple(`Cancel ${taskLabel}`, `${task.Name} cancelled`, `Failed to cancel ${task.Name}`, UpdateDocumentTaskWeb(obj));
                } else if (type.includes("Remind")) {
                    const reminderObj = { TaskId: task.Id, Comment: comment, userId: loginContext.userID };
                    notifyResultSimple("Send Reminder", `Reminder sent for ${task.Name}`, `Could not send reminder for ${task.Name}`, sendTaskDocumentReminder(reminderObj));
                } else if (type === "Request Review Task") {
                    const fd = new FormData();
                    fd.append("Comment", obj.Comment);
                    fd.append("TaskId", obj.TaskId);
                    fd.append("DocumentType", task.DocumentTypeId);
                    notifyResult("Request Review", `Requested review for ${task.Name}`, `Could not request review for ${task.Name}`, RequestReviewDCFromWeb(fd));
                }
            }
        }

        // STANDARD TASKS
        else if (task.TaskTypeId === 1) {
            if (type === "Approve Task") {
                notifyResult(`Approve ${taskLabel}`, `${task.Name} approved`, `Could not approve ${task.Name}`, ApproveTaskRegular(obj));
            } else if (type === "Complete Task") {
                notifyResult(`Complete ${taskLabel}`, `${task.Name} completed`, `Could not complete ${task.Name}`, ApproveTaskRegular(obj));
            } else if (type === "Decline Task") {
                notifyResult(`Decline ${taskLabel}`, `${task.Name} declined`, `Could not decline ${task.Name}`, DeclineTaskRegular(obj));
            } else if (type === "Cancel Task") {
                notifyResult(`Cancel ${taskLabel}`, `${task.Name} cancelled`, `Could not cancel ${task.Name}`, CancelTaskRegular(obj));
            } else if (type.includes("Remind")) {
                const reminderObj = { TaskId: task.Id, Comment: comment, userId: loginContext.userID };
                notifyResultSimple("Send Reminder", `Reminder sent for ${task.Name}`, `Could not send reminder for ${task.Name}`, sendTaskRegularReminder(reminderObj));
            } else if (type === "Request Review Task" || type === "Request Review") {
                notifyResult("Request Review", `Requested review for ${task.Name}`, `Could not request review for ${task.Name}`, RequestReviewRegular(obj));
            } else if (type === "Archive Task") {
                notifyResultSimple(`Archive ${taskLabel}`, `${task.Name} archived`, `Could not archive ${task.Name}`, ArchiveTaskRegular(obj));
            } else if (type === "Un-Archive Task") {
                notifyResultSimple(`Un-Archive ${taskLabel}`, `${task.Name} un-archived`, `Could not un-archive ${task.Name}`, UnArchiveTaskRegular(obj));
            }
        }
    };

    const handleSubmit = () => {
        if (task.DocumentTypeId === 3 && type !== "Request Review Task") {
            submitPPTAction(comment);
        } else {
            submitAction();
        }
    };

    const shortenFileName = (fileName) => {
        if (fileName.length > 20) {
            const fileNameArr = fileName.split('.');
            const fileExtension = fileNameArr[fileNameArr.length - 1];
            return (fileName.slice(0, 20 - fileExtension.length - 4) + "...." + fileExtension);
        }
        return fileName;
    };

    const onBrowseFilesLoaded = (convertedFiles) => {
        setSelectedFiles((prev) => {
            if (prev.length === 0) return convertedFiles;
            const merged = [...prev];
            convertedFiles.forEach((file) => {
                if (!merged.some((f) => f.name === file.name)) {
                    merged.push(file);
                }
            });
            return merged;
        });
    };

    const filesToBase64 = (files) => {
        let convertedFiles = [];
        let loadedFilesCount = 0;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
                convertedFiles = [
                    ...convertedFiles,
                    { name: file.name, FileName: file.name, FileContentType: file.type, Base64String: base64String }
                ];
                loadedFilesCount++;
                if (loadedFilesCount === files.length) {
                    onBrowseFilesLoaded(convertedFiles);
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const browseFile = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const newSelectedFiles = Array.from(e.target.files);
        e.target.value = null;
        filesToBase64(newSelectedFiles);
    };

    const deleteBrowseFile = (e, name) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedFiles((prev) => prev.filter((file) => file.name !== name));
    };

    const hideFileUpload = type === "Cancel Task" || type.includes("Remind");

    return (
        <div onClick={(e) => e.stopPropagation()}>
            {task?.DocumentTypeId === 3 && type !== "Request Review Task" ? (
                <ApprovePanelPowerpoint
                    show={show}
                    submitAction={submitPPTAction}
                    setShowModal={onHide}
                    actionType={type}
                    taskName={task.Name}
                />
            ) : (
                <Modal dialogClassName="actions-panel-container" show={show} onHide={onHide} contentClassName="actions-panel-content">
                    <Modal.Header className="header-popup">
                        <Modal.Title className="actions-panel-title">
                            {customLabel ?? type.replace("Task", labels?.TaskSingular ?? "Task")}
                        </Modal.Title>
                        <button className="modal-close-btn" onClick={onHide}></button>
                    </Modal.Header>
                    <div className="select-member-divider-line"></div>
                    <Modal.Body>
                        {(isLoadingDocument || isSubmittingTask || isLoadingReminder) ? (
                            <div style={{ padding: '30px 100px', textAlign: 'center' }}>
                                <PulseLoader />
                            </div>
                        ) : (
                            <>
                                <h3 className="actions-panel-title">{task.Name}</h3>
                                <Form.Group className="actions-panel-comments">
                                    <Form.Label className="comments-title">Comments (optional)</Form.Label>
                                    <Form.Control
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        as="textarea"
                                        rows="6"
                                        placeholder="Enter Comment"
                                    />
                                </Form.Group>

                                {hideFileUpload ? null : (
                                    <Form.Group className="upload-file-box">
                                        <Form.Control
                                            className="browse-btn-hidden"
                                            type="file"
                                            multiple
                                            onChange={browseFile}
                                        />
                                        <Button className="browse-file-btn add-attachment-btn"></Button>
                                        {selectedFiles.map((file) => (
                                            <div className="single-file" key={file.name}>
                                                <span className="file-name">{shortenFileName(file.name)}</span>
                                                <Button className="delete-file-btn" onClick={(e) => deleteBrowseFile(e, file.name)}>x</Button>
                                            </div>
                                        ))}
                                    </Form.Group>
                                )}

                                <div className="action-btns">
                                    {button === "Cancel" ? (
                                        <Button className="btn-wide btn-outlined" onClick={onHide} variant="primary">Back</Button>
                                    ) : (
                                        <Button className="btn-wide btn-outlined" onClick={onHide} variant="primary">Cancel</Button>
                                    )}
                                    {(button === "Cancel" || button === "Complete" || button === "Approve" || button === "Decline" || button === "Archive" || button === "Un-Archive") ? (
                                        <Button
                                            className="btn-wide"
                                            ref={btnRef}
                                            onClick={handleSubmit}
                                            variant="primary"
                                        >
                                            {button} {labels?.TaskSingular ?? 'Task'}
                                        </Button>
                                    ) : (
                                        <Button
                                            className="btn-wide"
                                            ref={btnRef}
                                            onClick={handleSubmit}
                                            variant="primary"
                                        >
                                            {button}
                                        </Button>
                                    )}
                                </div>
                            </>
                        )}
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
};

export default TasksActionsPanelNew;
